import JobTemplateList from './JobTemplateList';

export default JobTemplateList;
